"use client"

import { useState } from "react"
import Link from "next/link"
import { primaryButtonClass } from "@/app/components/styles"

const storageKey = "v8studio-cookie-ok"

export function CookieNotice() {
  const [hidden, setHidden] = useState(false)
  if (hidden) return null

  function acceptCookies() {
    window.localStorage.setItem(storageKey, "1")
    document.documentElement.setAttribute("data-cookie-ok", "")
    setHidden(true)
  }

  return (
    <div
      data-cookie-banner
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-3xl flex-col gap-4 rounded-3xl bg-white p-5 shadow-2xl ring-1 ring-line sm:flex-row sm:items-center"
    >
      <p className="text-sm leading-relaxed text-muted">
        Используя сайт, вы соглашаетесь на cookie, чтобы запомнить этот выбор.{" "}
        <Link href="/privacy" className="text-accent underline-offset-2 hover:underline">
          Политика конфиденциальности
        </Link>
      </p>
      <button type="button" className={`${primaryButtonClass} shrink-0`} onClick={acceptCookies}>
        Я согласен
      </button>
    </div>
  )
}
